import { ElectricityReceipt } from '@/components/receipts/ElectricityReceipt';
import { ExamReceipt } from '@/components/receipts/ExamReceipt';
import { GenericTransactionReceipt } from '@/components/transactions/GenericTransactionReceipt';
import { Button } from '@/components/ui/Button';
import { Modal } from '@/components/ui/Modal';
import type { TransactionItem } from '@/types/transactions';
import { transactionToBillReceipt } from '@/utils/transactionFormatters';

interface TransactionReceiptModalProps {
  open: boolean;
  onClose: () => void;
  transaction: TransactionItem | null;
  showProfit?: boolean;
}

export function TransactionReceiptModal({
  open,
  onClose,
  transaction,
  showProfit = false,
}: TransactionReceiptModalProps) {
  if (!transaction) return null;

  const billReceipt = transactionToBillReceipt(transaction);

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="lg"
      title="Transaction receipt"
      description={transaction.reference}
      bodyClassName="px-3 py-3 sm:px-4"
      footer={
        <Button fullWidth onClick={onClose}>
          Close
        </Button>
      }
    >
      {billReceipt?.type === 'electricity' ? (
        <ElectricityReceipt receipt={billReceipt} />
      ) : billReceipt?.type === 'exam' ? (
        <ExamReceipt receipt={billReceipt} />
      ) : (
        <GenericTransactionReceipt transaction={transaction} showProfit={showProfit} />
      )}
    </Modal>
  );
}
